import ExpansionQuestDTO from "../../models/quest/ExpansionQuestDTO";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function getQuests(client: BackendClient): Promise<Array<ExpansionQuestDTO>> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<Array<ExpansionQuestDTO>>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.GetQuests}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when getting quests: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }